import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Stock {
  static getStockTotal () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_resumen_stock_consolidado_total')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }
}

export default Stock
